(function($, undefined) {
	
	'use strict';
	
	
	var init = function () {
		$('.scroll-to-anchor-item').on('click', function(e) {
			var element = $($(this).attr('href'));
			if (element.length) {
				$("html, body").animate({
					scrollTop: element.offset().top - 15
				}, 500);
				return false;
			}
		});
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
